import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Box, Typography } from '@mui/material';

import SearchBar from 'main/components/bar/SearchBar';
import SearchTemplates from 'main/components/search/Templates';
import Utils from 'main/components/utils/Utils';

const useStyles = makeStyles()({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        background: '#fff',
        position: 'relative',
        overflow: 'hidden',
        maxHeight: 700,
        padding: '60px 0 100px',
        maskImage: 'linear-gradient(to top, transparent 0%, black 18%)',
        '@media (max-width: 720px)': {
            justifyContent: 'initial',
            padding: '60px 0 100px'
        }
    },
    heading: {
        fontSize: 48,
        textAlign: 'center',
        '@media (max-width: 720px)': {
            fontSize: 32,
            padding: 30,
            textAlign: 'left'
        }
    },
    search: {
        maxWidth: 780,
        padding: 40,
        margin: '0 auto',
        '@media (max-width: 720px)': {
            padding: 20
        }
    },
    searchBar: {},
    field: {
        padding: 10,
        borderRadius: 100,
        border: '1px solid #fff',
        background: 'rgba(255, 255, 255, 0.3)'
    },
    input: {
        borderRadius: 18,
        fontSize: 20,
        padding: 10,
        '& .MuiInput-input': {
            fontSize: '20px'
        },
        '& .MuiInputBase-input': {
            color: '#bdbdbd'
        }
    },
    submitButton: {
        borderRadius: 100,
        '@media (max-width: 720px)': {
            padding: '12px 20px'
        }
    },
    bg1: {
        position: 'absolute',
        top: -400,
        left: 100,
        opacity: 0.2,
        width: 760,
        height: 760,
        background: '#FF6600',
        filter: 'blur(228.965px)',
        zIndex: 0,
        '@media (max-width: 720px)': {
            display: 'none'
        }
    },
    bg2: {
        position: 'absolute',
        left: -100,
        bottom: -200,
        opacity: 0.2,
        width: 760,
        height: 760,
        background: '#A0B2CB',
        filter: 'blur(228.965px)',
        zIndex: 0,
        '@media (max-width: 720px)': {
            display: 'none'
        }
    },
    bg3: {
        position: 'absolute',
        right: -400,
        bottom: -200,
        opacity: 0.2,
        width: 760,
        height: 760,
        background: '#ff6600',
        filter: 'blur(228.965px)',
        zIndex: 0,
        '@media (max-width: 720px)': {
            right: 0,
            width: 480,
            bottom: 239,
            height: 480
        }
    },
    chip: {
        height: 46,
        fontSize: 16,
        background: '#FAFAFA'
    },
    chips: {
        justifyContent: 'center',
        '@media (max-width: 720px)': {
            justifyContent: 'initial',
            flexWrap: 'wrap'
        }
    }
});

const Search = () => {
    const { classes } = useStyles();
    const isMobile = Utils.isMobile();
    return (
        <Box className={classes.root} style={{ height: isMobile ? 'initial' : '100vh' }}>
            <div className={classes.bg2} />
            <div className={classes.bg3} />
            <div className={classes.bg1} />

            <Box style={{ zIndex: 99 }}>
                <Typography className={classes.heading} variant="h1">
                    {'Vulnerability Database'}
                    <br />
                    {'and Search Engine'}
                </Typography>

                <Box className={classes.search}>
                    <SearchBar
                        hintText={isMobile ? 'Search...' : 'Vulnerabilities or exploits'}
                        hideSettings
                        customClasses={{
                            searchBar: classes.searchBar,
                            input: classes.input,
                            field: classes.field,
                            submitButton: classes.submitButton
                        }}
                        showSubmitButton={!isMobile}
                        showSearchButton={isMobile}
                    />
                    <SearchTemplates customClasses={{ chips: classes.chips, chip: classes.chip }} />
                </Box>
            </Box>
        </Box>
    );
};

export default Search;
